import { navigate } from 'gatsby'
import React, { ComponentType, useContext } from 'react'

import { useOrganization } from '@application/Interfaces/Hooks/useOrganization/useOrganization'
import { useTranslation } from '@application/Interfaces/Hooks/useTranslation'
import { AlternateUrlType, HeaderThemeModeType } from '@application/Types/ComponentTypes'
import { Nullable } from '@application/Types/Opt'
import { languages } from '@src/Application/Constants/languageConstants'
import { Context } from '@src/Infrastructure/Context'

import { LanguageButton, LanguageButtonProps } from './LanguageButton'
import { DropdownMenu, MenuItem, Title } from './LanguageMenu.styled'
import { getAlternativePageUrl, onChangeLanguage } from './utils'

type LanguageMenuProps = {
    className?: string
    mode?: HeaderThemeModeType
    alternateUrls?: Nullable<AlternateUrlType[]>
}

export const LanguageMenu: ComponentType<LanguageMenuProps> = ({ className, mode = 'Dark', alternateUrls = [] }) => {
    const { t } = useTranslation()
    const organization = useOrganization()
    const context = useContext(Context)

    const lngs = languages.filter((lang) => organization.languages.includes(lang.locale))

    return lngs.length > 1 ? (
        <DropdownMenu
            alignment="right"
            menuButton={(props: LanguageButtonProps) => <LanguageButton {...props} mode={mode} />}
            menuButtonProps={{ currentLanguage: context.locale }}
            aria-label="language control"
            className={className}
        >
            <Title>{t('language')}</Title>
            {lngs.map((lang) => (
                <MenuItem
                    key={lang.locale}
                    onClick={onChangeLanguage(lang.locale, navigate, getAlternativePageUrl(lang.locale, alternateUrls))}
                    role="menuitem"
                >
                    {lang.name}
                </MenuItem>
            ))}
        </DropdownMenu>
    ) : null
}
